var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiveStarsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 25,
    viewBox: "0 0 136 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.77L18.18 21.5L16.54 14.47L22 9.74L14.81 9.13L12 2.5L9.19 9.13L2 9.74L7.46 14.47L5.82 21.5L12 17.77Z",
    fill: "#54EF9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 17.77L46.18 21.5L44.54 14.47L50 9.74L42.81 9.13L40 2.5L37.19 9.13L30 9.74L35.46 14.47L33.82 21.5L40 17.77Z",
    fill: "#54EF9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 17.77L74.18 21.5L72.54 14.47L78 9.74L70.81 9.13L68 2.5L65.19 9.13L58 9.74L63.46 14.47L61.82 21.5L68 17.77Z",
    fill: "#54EF9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 17.77L102.18 21.5L100.54 14.47L106 9.74L98.81 9.13L96 2.5L93.19 9.13L86 9.74L91.46 14.47L89.82 21.5L96 17.77Z",
    fill: "#54EF9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124 17.77L130.18 21.5L128.54 14.47L134 9.74L126.81 9.13L124 2.5L121.19 9.13L114 9.74L119.46 14.47L117.82 21.5L124 17.77Z",
    fill: "#54EF9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveStarsIcon);
export default __webpack_public_path__ + "static/media/fiveStarsIcon.f882dbd303c5e479d3035e380024e14d.svg";
export { ForwardRef as ReactComponent };